import React, { useEffect, useRef, useState } from 'react';
import ImageCropDialog from './ImageCropDialog';

export default function useImageCrop() {
  const [pending, setPending] = useState(null);
  const previews = useRef([]);
  useEffect(() => {
    const urls = previews.current;
    return () => urls.forEach(url => URL.revokeObjectURL(url));
  }, []);

  const openCrop = (source, onApply, aspectRatio) => setPending({ source, onApply, aspectRatio });
  const cropDialog = pending && <ImageCropDialog source={pending.source} aspectRatio={pending.aspectRatio} onCancel={() => setPending(null)}
    onApply={file => {
      const preview = URL.createObjectURL(file);
      previews.current.push(preview);
      pending.onApply(file, preview);
      setPending(null);
    }} />;
  return { openCrop, cropDialog };
}
